/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinancialExportSummary
 */
export interface FinancialExportSummary {
    /**
     * 
     * @type {number}
     * @memberof FinancialExportSummary
     */
    totalEntryFees?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialExportSummary
     */
    totalRefunds?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialExportSummary
     */
    totalPrizes?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialExportSummary
     */
    totalPenalties?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialExportSummary
     */
    netRevenue?: number;
}

/**
 * Check if a given object implements the FinancialExportSummary interface.
 */
export function instanceOfFinancialExportSummary(value: object): value is FinancialExportSummary {
    return true;
}

export function FinancialExportSummaryFromJSON(json: any): FinancialExportSummary {
    return FinancialExportSummaryFromJSONTyped(json, false);
}

export function FinancialExportSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialExportSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'totalEntryFees': json['totalEntryFees'] == null ? undefined : json['totalEntryFees'],
        'totalRefunds': json['totalRefunds'] == null ? undefined : json['totalRefunds'],
        'totalPrizes': json['totalPrizes'] == null ? undefined : json['totalPrizes'],
        'totalPenalties': json['totalPenalties'] == null ? undefined : json['totalPenalties'],
        'netRevenue': json['netRevenue'] == null ? undefined : json['netRevenue'],
    };
}

export function FinancialExportSummaryToJSON(json: any): FinancialExportSummary {
    return FinancialExportSummaryToJSONTyped(json, false);
}

export function FinancialExportSummaryToJSONTyped(value?: FinancialExportSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalEntryFees': value['totalEntryFees'],
        'totalRefunds': value['totalRefunds'],
        'totalPrizes': value['totalPrizes'],
        'totalPenalties': value['totalPenalties'],
        'netRevenue': value['netRevenue'],
    };
}

